/** One render decision also determines which component owns viewer hotkeys. */
export function resolveLabelingViewerRoute({
  loading,
  error,
  worklist,
  hasCurrentStudy,
  readOnly,
}: {
  loading: boolean;
  error: unknown;
  worklist:
    | {
        studies: readonly unknown[];
        project_type?: string;
        factory_workflow?: string;
        study_observation_task?: unknown;
      }
    | null
    | undefined;
  hasCurrentStudy: boolean;
  readOnly: boolean;
}) {
  if (loading) return "loading";
  if (error) return "error";
  if (!worklist || worklist.studies.length === 0) return "empty";
  // A joint review has its own pages; it never opens in the labeling viewer.
  if (worklist.project_type === "joint_review") return "joint-review";
  if (!hasCurrentStudy) return "invalid-study";
  if (
    worklist.study_observation_task !== undefined &&
    (worklist.project_type !== "classification" ||
      worklist.factory_workflow === "cohort_segmentation")
  )
    return "invalid-anatomy";
  if (!readOnly && worklist.factory_workflow === "cohort_segmentation") return "factory";
  if (!readOnly && worklist.project_type === "segmentation_study") return "study";
  return "standalone";
}
